export var clientOverviewMapper = function (data) {
    var result = {};
    if (data) {
        result.profileImg = data.profileImg;
        result.name = data.name;
        result.mobileNo = data.mobileNo;
        result.phoneNo = data.phoneNo;
        result.emailId = data.emailId;
        result.preferredLang = data.preferred_Lang;
        result.gender = data.gender;
        result.dob = data.dob;
        result.organization = data.organization;
        result.designation = data.designation;
        result.city = data.city;
        result.state = data.state;
        result.pinCode = data.pincode;
        result.address = data.address;
        result.category = data.category;
        result.clientTier = data.client_Tier;
        result.potentialValue = data.potential_value;
        result.aum = data.aum;
        result.walletShare = data.walletShare;
        result.netWorth = data.netWorth;
        result.prodInvested = data.prod_Invested;
        result.lastInvestmentDate = data.last_InvestmentDate;
        result.clcStage = data.clC_Stage;
        result.lasOffer = data.laS_Offer;
        result.potentialTier = data.potential_Tier;
        result.potentialST = data.potential_ST;
        result.recommendedProd = data.recommended_Prod;
        result.recommendedSegment = data.recommended_Segment;
        result.vintage = data.vintage;
        result.rating = data.rating;
        result.nps = data.nps;
        result.riskCategory = data.risk_Category;
        result.twitterId = data.twitterId;
        result.facebookId = data.facebookId;
        result.linkedInId = data.linkedInId;
        result.profiler = data.profiler;
        result.branch = data.branch;
        result.pan = data.pan;
        result.aadhar = data.aadhar;
        result.fatca = data.fatca;
        result.kyc = data.kyc;
        result.ckyc = data.ckyc;
        result.ckycNo = data.ckyC_No;
        result.zeroising = data.zeroising;
        result.ecn = data.ecn;
        result.loa = data.loa;
        result.thirdPartyPOA = data.thirdPartyPOA;
        result.thirdPartyPOADocumentUploadFlag =
            data.thirdPartyPOADocumentUploadFlag;
        result.poa = data.poa;
        result.investmentDeclare = data.investment_Declare;
        result.onlineEnabled = data.online_Enabled;
        result.dormantStatus = data.dormant_Status;
        result.dncStatus = data.dnC_Status;
        result.exceptionHaircut = data.exception_Haircut;
        result.subscription = data.subscription;
        result.b2b = data.b2B;
        result.passwordReset = data.password_Reset;
        result.imageName = data.imageName;
        result.profileImage = data.profileImage;
        result.lastInvstProd = data.last_InvstProd;
        result.wealthProfiler = data.wealthProfiler;
        result.wealthRMCode = data.wealtH_RM_CODE;
        result.isClientProfilerShow = data.isClientProfilerShow;
        result.lobId = data.lobId;
        result.lob = data.lob;
        result.acType = data.actype;
        result.userName = data.userName;
        result.clientGroup = data.clientgroup;
        result.peakTier = data.peak_Tier;
        result.whatsAppConsentFlag = data.whatsApp_ConsentFlag;
        result.memorandum = data.memorandum;
        result.tradingStatus = data.tradingStatus;
        result.tradingStatusReason = data.tradingStatusReason;
        result.dnd = data.dnd;
        result.dndReason = data.dndreason;
        result.kycDocPath = data.kycDoc_Path;
        result.tradingReason = data.tradingReason;
        result.clientOwnerId = data.clientOwnerId;
        result.reasons = data.reasons;
        result.mode = data.mode;
        result.aadharPanLinkStatus = data.aadharPanLinkStatus;
        result.openMeeting = data.openMeeting;
        result.isAccountClosed = data.isAccountClosed;
        result.tradingStatusOmnysis = data === null || data === void 0 ? void 0 : data.tradingStatus_omnysis;
        result.tradingReasonOmnysis = data === null || data === void 0 ? void 0 : data.tradingReason_omnysis;
    }
    return result;
};
